import { Flyer } from '@/graphql/types';
import { StickyHeader, HeaderFixed, BottomViewFlyers } from '@/components';
import { FlyerType } from '@/config/constants';
import {
  BodyLargeEmphasized,
  ContentSwitcher,
  FlyerboardHeader,
} from '@/design-system';
import { Subscription } from '@/types/subscriptions';
import styles from './Upcoming.styles';
import { FilterType } from '../ExploreResults';
import { Calendar } from './components/Calendar/Calendar';

interface UpcomingProps {
  trackId: string;
  flyerType: string;
  selectedAudienceId: string;
  filters: FilterType;
  stickyHeaderHeight: number;
  stickyTop: number;
  flyers: Array<Flyer>;
  subscriptions: Subscription[];
  setFilters: (filters: FilterType) => void;
  onTabChangeFlyerType: (newFlyerType: string) => void;
  handleClickFlyerType: () => void;
  onStickyTopChanged: (stickyTop: number) => void;
}

export const Upcoming: React.FC<UpcomingProps> = ({
  trackId,
  flyerType,
  filters,
  stickyHeaderHeight,
  stickyTop,
  flyers,
  subscriptions,
  selectedAudienceId,
  setFilters,
  onTabChangeFlyerType,
  handleClickFlyerType,
  onStickyTopChanged,
}) => (
  <>
    <div className={styles.header}>
      <h4 data-testid="pageTitle">
        <BodyLargeEmphasized>Upcoming</BodyLargeEmphasized>
      </h4>
    </div>
    <HeaderFixed>
      <ContentSwitcher
        trackId={trackId}
        options={[
          {
            label: 'School',
            value: FlyerType.school,
          },
          {
            label: 'Community',
            value: FlyerType.community,
          },
        ]}
        onChange={onTabChangeFlyerType}
        selected={flyerType}
      />
      <FlyerboardHeader
        selectedAudienceId={selectedAudienceId}
        subscriptions={subscriptions}
        type={flyerType}
      />
    </HeaderFixed>
    <div className={styles.container}>
      <StickyHeader
        stickyHeaderHeight={stickyHeaderHeight}
        onStickyTopChanged={onStickyTopChanged}
      />
      <Calendar trackId={trackId} stickyTop={stickyTop} flyers={flyers} />
    </div>
    <BottomViewFlyers
      label={`View Upcoming ${
        FlyerType.school === flyerType ? 'Community' : 'School'
      } Flyers`}
      onClick={handleClickFlyerType}
      variant={FlyerType[flyerType]}
    />
  </>
);
